
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="isShowing"
    width="60%"
    :fullscreen="isFullscreen"
    class="fixHeight"
    :close-on-click-modal="false"
    @open="initial()"
  >
    <el-form
      ref="LCZ"
      v-loading="isSaving"
      label-position="top"
      :model="$props.lcz"
    >
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="Carrier">
            <el-input
              v-if="carrierDisable"
              v-model="lcz.carrier.name"
              :disabled="true"
              class="w-100"
            />
            <el-select
              v-if="!carrierDisable"
              v-model="lcz.carrier"
              :remote-method="carrierQuerySearch"
              placeholder="Enter a Carrier and select"
              :trigger-on-focus="false"
              class="w-100"
              :debounce="500"
              filterable
              remote
              value-key="id"
              :loading="isLoading"
              @change="handleSelectCarrier"
            >
              <el-option
                v-for="item in carriers"
                :key="item.id"
                :label="item.name"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Location"
            prop="location.suburb"
            :rules="[
              { required: true, message: 'Location is required', trigger: 'blur' }
            ]"
          >
            <el-select
              v-model="lcz.location"
              :remote-method="locationQuerySearch"
              placeholder="Enter a location"
              :trigger-on-focus="false"
              class="w-100"
              :debounce="500"
              filterable
              remote
              :loading="isLoading"
              :disabled="locationDisable"
              value-key="id"
              @change="handleSelectLocation"
            >
              <el-option
                v-for="item in locations"
                :key="item.id"
                :label="formatSuburbByLocation(item)"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item
            label="Zone"
            prop="zone.desc"
            :rules="[
              { required: true, message: 'Zone is required', trigger: 'blur' }
            ]"
          >
            <el-select
              v-model="lcz.zone.desc"
              :remote-method="zoneQuerySearch"
              placeholder="Enter a zone"
              :trigger-on-focus="false"
              class="w-100"
              :debounce="500"
              filterable
              value-key="id"
              remote
              clearable
              allow-create
              :loading="isLoading"
              @change="handleSelectZone"
            >
              <el-option
                v-for="item in zones"
                :key="item.id"
                :label="item.desc"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          v-if="$_.get(lcz, 'zone_parent')"
          :span="12"
        >
          <el-form-item label="Zone Parent">
            <el-select
              v-model="lcz.zone_parent.desc"
              :remote-method="zoneQuerySearch"
              placeholder="Enter a zone parent"
              :trigger-on-focus="false"
              class="w-100"
              :debounce="500"
              filterable
              remote
              clearable
              allow-create
              value-key="id"
              :loading="isLoading"
              @change="handleSelectZoneParent"
            >
              <el-option
                v-for="item in zones"
                :key="item.id+1"
                :label="item.desc"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item
            label="Hub/Depot"
            prop="hub.desc"
          >
            <el-select
              v-model="hubDescription"
              :remote-method="hubQuerySearch"
              placeholder="Enter a hub/depot"
              :trigger-on-focus="false"
              class="w-100"
              :debounce="500"
              filterable
              value-key="id"
              remote
              clearable
              allow-create
              :loading="isLoading"
              @change="handleSelectHub"
            >
              <el-option
                v-for="item in hubs"
                :key="item.id"
                :label="item.desc"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          :span="12"
        >
          <el-form-item label="Remote">
            <el-input
              v-model="lcz.zone_remote"
              class="w-100"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="isShowing = false">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="create"
      >
        Save
      </el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  props: {
    lcz: {
      type: Object,
      required: false,
      default: null
    },
    operator: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {
      isShowing: false,
      isSaving: false,
      isFullscreen: false,
      zones: [],
      hubs: [],
      locations: [],
      isLoading: false,
      carrierDisable: true,
      locationDisable: false,
      carrierName: null,
      carriers: [],
      form: {}
    }
  },
  computed: {
    hubDescription: {
      get () {
        return this.$_.get(this.lcz, 'hub.desc', '')
      },
      set (value) {
        if (value && typeof value === 'object') {
          this.lcz.hub = value
          return
        }

        this.ensureHubObject()
        this.lcz.hub.desc = value || ''
      }
    }
  },
  methods: {
    initial () {
      this.ensureHubObject()

      if (!this.$props.operator) {
        if (this.$props.lcz.carrier.id) {
          this.carrierQuerySearch(this.$props.lcz.carrier.name)
        }
      }
      if (this.$props.lcz.location.suburb) {
        this.locationQuerySearch(this.$props.lcz.location.suburb)
      }
    },
    getTitle () {
      if (this.operator) {
        return 'Create Location, Carrier, Zones'
      } else {
        return 'Edit Location, Carrier, Zones'
      }
    },
    showDialog () {
      this.isShowing = true
      this.step = 1
    },
    closeDialog () {
      this.isShowing = false
    },
    ensureHubObject () {
      if (!this.lcz.hub || typeof this.lcz.hub !== 'object') {
        this.$set(this.lcz, 'hub', {})
      }
    },
    create () {
      this.$refs.LCZ.validate((valid) => {
        if (valid) {
          this.isSaving = true
          if (this.operator) {
            this.$sdk.locationcarrierzone.create(this.lcz, (builder) => {
              builder.context = { resource: 'pivot' }
            }).then((res) => this.$message({ message: 'Successfully saved', type: 'success' }))
              .finally(() => {
                this.isLoading = false
                this.isSaving = false
                this.$emit('refresh')
                this.closeDialog()
              })
          } else {
            this.lcz.update(
              (builder) => {
                builder
                  .context = { resource: 'pivot' }
              }).then((res) => this.$message({ message: 'Successfully saved', type: 'success' }))
              .finally(() => {
                this.isLoading = false
                this.isSaving = false
                this.$emit('refresh')
                this.closeDialog()
              })
          }
        }
      })
    },
    zoneQuerySearch (queryString) {
      this.isLoading = true
      this.$sdk.dictionary_zone.list(builder => {
        builder.filters = { 'dictionary_zone_carrier_or_null': this.$route.params.carrierId, 'dictionary_zone_desc': queryString }
      }).then(res => {
        this.zones = (res)
      })
        .finally(() => {
          this.isLoading = false
        })
    },
    hubQuerySearch (queryString) {
      this.isLoading = true
      this.$sdk.dictionary_hub.list(builder => {
        builder.filters = { 'dictionary_hub_carrier_or_null': this.$route.params.carrierId, 'dictionary_hub_desc': queryString }
      }).then(res => {
        this.hubs = (res)
      })
        .finally(() => {
          this.isLoading = false
        })
    },
    carrierQuerySearch (queryString) {
      this.isLoading = true
      this.$sdk.carrier.list(builder => {
        builder.order = 'name:asc'
        builder.filters = { 'name': queryString }
      }).then(res => {
        this.carriers = res
      })
        .finally(() => {
          this.isLoading = false
        })
    },
    locationQuerySearch (queryString) {
      this.isLoading = true
      this.$sdk.dictionary_location.list(builder => {
        builder.filters = { 'dictionary_location_find': queryString }
        builder.order = 'suburb:asc'
      }).then(res => {
        this.locations = res
        this.isLoading = false
      })
    },
    handleSelectZone (item) {
      this.lcz.zone = item
    },
    handleSelectHub (item) {
      if (item && typeof item === 'object') {
        this.lcz.hub = item
        return
      }

      this.ensureHubObject()
      this.lcz.hub.desc = item || ''
    },
    handleSelectZoneParent (item) {
      this.lcz.zone_parent = item
    },
    handleSelectLocation (item) {
      this.lcz.location = item
    },
    formatSuburbByLocation (location) {
      if (location) {
        return `${location.suburb}, ${location.state}, ${location.postcode}`
      } else return ''
    },
    handleSelectCarrier (item) {
      this.lcz.carrier = item
      this.carrierName = item.name
    }
  }

}
</script>

<style>

</style>
